export default __webpack_public_path__ + "static/media/qr-create-vc-dev.93a7e352.png";